import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { PageLayoutComponent } from './page-layout.component';
import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
  declarations: [PageLayoutComponent, MainLayoutComponent],
  imports: [CommonModule, MatIconModule, MatTreeModule, RouterModule, MatButtonModule, MatTooltipModule, NgxPermissionsModule.forChild()],
  exports: [PageLayoutComponent, MainLayoutComponent],
})
export class PageModule { }
